export default {
  namespaced: true,
  state: getInitialState(),
  mutations: {
    hideSnackbar(state) {
      state.visible = false
    },
    error(state, payload) {
      openSnackbar(state, payload)
      state.color = 'red'
    },
    success(state, payload) {
      openSnackbar(state, payload)
      state.color = 'success'
    },
    info(state, payload) {
      openSnackbar(state, payload)
      state.color = 'info'
    },
  },
  actions: {
    error: ({ commit }, payload) => callAction('error', commit, payload),
    info: ({ commit }, payload) => callAction('info', commit, payload),
    success: ({ commit }, payload) => callAction('success', commit, payload),
  },
}

function getInitialState() {
  return {
    visible: false,
    text: '',
    color: 'red',
    timeout: 3000,
    onClose: async () => undefined,
  }
}

function openSnackbar(state, payload) {
  const initialState = getInitialState()
  const { text, onClose, timeout = initialState.timeout } = payload

  state.visible = true
  state.text = text
  state.timeout = timeout
  state.onClose = onClose
}

function callAction(type, commit, payload) {
  const timeout = payload.timeout || getInitialState().timeout
  commit(type, payload)

  if (payload.timeout === -1) return

  setTimeout(() => {
    commit('hideSnackbar')
  }, timeout)
}
